export default __webpack_public_path__ + "d9f27cc6cf946dd54ff9e43895478072.png";